import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Logo } from '../../../theme/logo';

export interface LayoutProps {
  children: React.ReactNode;
}

export function AuthLayout({ children }: LayoutProps): React.JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh', // Full height of the viewport
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column',
          justifyContent: 'center', // Center the entire content vertically
          alignItems: 'center', // Center the entire content horizontally
          p: 3,
          overflowY: 'auto',
        }}
      >
        {/* Logo positioned at the top center */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 6 }}>
          <Logo color="dark" height={95} width={300} />
        </Box>
        {/* Centered SignInForm */}
        <Box sx={{ maxWidth: '450px', width: '100%' }}>
          {children}
        </Box>
      </Box>

      {/* <Box
        sx={{
          display: { xs: 'none', lg: 'flex' },
          flex: '1',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#3D6D81',
          color: '#fff',
          height: '100%', // Ensure the right side takes up the full height
          overflow: 'hidden', // Prevent overflow
        }}
      >
        <Stack spacing={3} sx={{ textAlign: 'center', height: '100%', overflow: 'auto', mt: 4 }}>
          <Stack spacing={1}>
            <Typography
              color="inherit"
              sx={{ fontSize: '24px', lineHeight: '32px' }}
              variant="h1"
            >
              Welcome to{' '}
              <Box component="span" sx={{ color: '#15b79e' }}>
                Business Vitality Tracker
              </Box>
            </Typography>
            <Typography align="center" variant="subtitle1">
              Verified Business Vitality Tracker
            </Typography>
          </Stack>
          <Box sx={{ display: 'flex', justifyContent: 'center', overflow: 'hidden' }}>
            <Box
              component="img"
              alt="Widgets"
              src="/assets/VGC_TransformLocal_Logo_BlueBackground.png"
              sx={{
                maxWidth: '100%', // Ensure the image does not exceed the container width
                maxHeight: '80%', // Limit the height to prevent overflow
                height: 'auto', // Maintain aspect ratio
                objectFit: 'cover', // Ensure it fills the space appropriately
              }}
            />
          </Box>
        </Stack>
      </Box> */}
    </Box>
  );
}
